"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/UZFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_242)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_242`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V23.9998H-6V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16.6956H30V23.9996H-6V16.6956Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V7.34896H-6V0.000244141Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 8.82715H30V15.1311H-6V8.82715Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V7.34896H-6V0.000244141Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.26716 3.67422C7.26716 2.55035 8.05705 1.61132 9.11188 1.38105C8.94663 1.34484 8.77796 1.32653 8.60879 1.32642C7.31209 1.32642 6.26099 2.37752 6.26099 3.67422C6.26099 4.97093 7.31209 6.02203 8.60879 6.02203C8.78162 6.02203 8.94981 6.00283 9.11188 5.9674C8.05705 5.73712 7.26716 4.7981 7.26716 3.67422ZM10.4994 4.74136L10.6584 5.23052H11.1727L10.7566 5.53294L10.9156 6.02203L10.4994 5.71969L10.0833 6.02203L10.2423 5.53294L9.82618 5.23052H10.3405L10.4994 4.74136ZM12.1411 4.74136L12.3 5.23052H12.8143L12.3982 5.53294L12.5572 6.02203L12.1411 5.71969L11.725 6.02203L11.8839 5.53294L11.4678 5.23052H11.9821L12.1411 4.74136ZM13.7827 4.74136L13.9416 5.23052H14.4559L14.0399 5.53294L14.1988 6.02203L13.7827 5.71969L13.3666 6.02203L13.5255 5.53294L13.1094 5.23052H13.6237L13.7827 4.74136ZM15.4243 4.74136L15.5833 5.23052H16.0976L15.6815 5.53294L15.8404 6.02203L15.4243 5.71969L15.0082 6.02203L15.1672 5.53294L14.751 5.23052H15.2653L15.4243 4.74136ZM17.0659 4.74136L17.2248 5.23052H17.7392L17.3231 5.53294L17.482 6.02203L17.0659 5.71969L16.6498 6.02203L16.8087 5.53294L16.3927 5.23052H16.9069L17.0659 4.74136ZM12.1411 3.03389L12.3 3.52298H12.8143L12.3982 3.82533L12.5572 4.31449L12.1411 4.01222L11.725 4.31449L11.8839 3.82533L11.4678 3.52298H11.9821L12.1411 3.03389ZM13.7827 3.03389L13.9416 3.52298H14.4559L14.0399 3.82533L14.1988 4.31449L13.7827 4.01222L13.3666 4.31449L13.5255 3.82533L13.1094 3.52298H13.6237L13.7827 3.03389ZM15.4243 3.03389L15.5833 3.52298H16.0976L15.6815 3.82533L15.8404 4.31449L15.4243 4.01222L15.0082 4.31449L15.1672 3.82533L14.751 3.52298H15.2653L15.4243 3.03389ZM17.0659 3.03389L17.2248 3.52298H17.7392L17.3231 3.82533L17.482 4.31449L17.0659 4.01222L16.6498 4.31449L16.8087 3.82533L16.3927 3.52298H16.9069L17.0659 3.03389ZM13.7827 1.32642L13.9416 1.81551H14.4559L14.0399 2.11785L14.1988 2.60702L13.7827 2.30467L13.3666 2.60702L13.5255 2.11785L13.1094 1.81551H13.6237L13.7827 1.32642ZM15.4243 1.32642L15.5833 1.81551H16.0976L15.6815 2.11785L15.8404 2.60702L15.4243 2.30467L15.0082 2.60702L15.1672 2.11785L14.751 1.81551H15.2653L15.4243 1.32642ZM17.0659 1.32642L17.2248 1.81551H17.7392L17.3231 2.11785L17.482 2.60702L17.0659 2.30467L16.6498 2.60702L16.8087 2.11785L16.3927 1.81551H16.9069L17.0659 1.32642Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_242`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as UZFlag };
